import { Aggregator as AggregatorBase } from '../../bases/aggregator';
import { getConfigurationValue } from '../../state/init';
import { isGetter } from '../../utils/object';
import { FEATURE_NAME } from './constants';
import { pick } from '../../utils/pick';

export class Aggregator extends AggregatorBase {
  constructor() {
    super({}, FEATURE_NAME);
    this.endpoint = getConfigurationValue(
      `instruments.features.${FEATURE_NAME}.endpoint`,
    );
    this.local_config = getConfigurationValue(
      `instruments.features.${FEATURE_NAME}.mapped_attributes`,
    );
  }

  getContext() {
    return super.getContext(FEATURE_NAME);
  }

  getHeaders() {
    return this.local_config.headers;
  }

  buildPayload() {
    const payload = Object.entries(this.local_config.headers).reduce(
      (acc, [key, value]) => {
        if (isGetter(this.local_config.headers, key)) {
          acc[key] = value;
        } else {
          acc[key] = super.getSharedContext(FEATURE_NAME)[value];
        }

        return acc;
      },
      {},
    );

    return { data: payload };
  }

  buildMetadataFromContext() {
    const collection = pick(
      super.getSharedContext(FEATURE_NAME),
      this.local_config.metadata,
    );

    if (!Object.keys(collection).length) {
      throw new Error('Metrics not found');
    }

    return {
      name: FEATURE_NAME,
      data: collection,
    };
  }
}
